import {PPRequest} from '@gongxigames/framework/integrations/pariplay/request/PPRequest';
import {PPEndGameResponse} from '@gongxigames/framework/integrations/pariplay/response/PPEndGameResponse';
import {Xhr} from '@gongxigames/framework/slot';

export class PPEndGameRequest extends PPRequest<PPEndGameResponse> {
    protected getURL(): string {
        return this.config.RgsUrl + '/client/' + this.config.EndUrl;
    }

    protected processResponse(data: any): void {
        this.response = new PPEndGameResponse(data);
        this.callback();
    }

    protected getParams(): string {
        const data: any = {};

        data.PlayerTokenId = this.config.playerTokenID;
        data.Id = this.config.ticketID;

        return Xhr.objectToKeyValue(data);
    }
}
